import { HeaderHeightContext } from 'expo-router/react-navigation';
import { useContext } from 'react';
import { View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { ContactProfile, ContactRecordingFab } from '@/components/organisms';

interface ContactProfileProps {
  readonly id: number;
}

export const ContactProfilePage = ({ id }: ContactProfileProps) => {
  const headerHeight = useContext(HeaderHeightContext) ?? 0;
  const { bottom } = useSafeAreaInsets();

  return (
    <View style={{ flex: 1, paddingTop: headerHeight }}>
      <ContactProfile id={id} bottomPadding={Math.max(bottom, 50)} />
      <ContactRecordingFab contactId={id} />
    </View>
  );
};
